module.exports = __webpack_public_path__ + "assets/img/brown_active.b9fa163c.png";